var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCar1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 47,
    viewBox: "0 0 46 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.387 32.3787H31.3212C31.6935 32.3787 31.998 32.6878 31.998 33.0657V39.1341C31.998 39.5119 31.6935 39.821 31.3212 39.821H11.387C11.0147 39.821 10.7102 39.5119 10.7102 39.1341V33.0657C10.7099 32.6878 11.0147 32.3787 11.387 32.3787Z",
    fill: "url(#paint0_linear_707_39389)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.387 7.66159L31.3212 7.66159C31.6935 7.66159 31.998 7.97069 31.998 8.34859V14.417C31.998 14.7948 31.6935 15.1039 31.3212 15.1039L11.387 15.1039C11.0147 15.1039 10.7102 14.7948 10.7102 14.417V8.34859C10.7099 7.97069 11.0147 7.66159 11.387 7.66159Z",
    fill: "url(#paint1_linear_707_39389)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9497 30.3185C12.9497 30.3185 11.474 30.768 11.2367 32.0573C9.55152 41.2079 14.1856 42.8615 14.1856 42.8615H14.9016C14.9016 42.8615 15.8143 42.3622 16.2356 42.3696C16.657 42.3771 16.8066 42.3696 16.8066 42.3696",
    fill: "url(#paint2_linear_707_39389)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0864 6.83157C13.0864 6.83157 12.1845 7.38067 11.9597 8.08384C11.7349 8.78702 11.5852 14.0134 11.8474 14.6403C12.1096 15.2675 12.7101 16.1422 12.7101 16.1422L13.6016 14.7542L13.0864 6.83157Z",
    fill: "url(#paint3_linear_707_39389)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3988 5.52651L16.9121 5.26036L13.8509 5.18908C13.8509 5.18908 12.5697 6.77131 12.6206 10.4771C12.6715 14.1828 12.9524 30.3179 12.9524 30.3179C12.9524 30.3179 14.4876 40.5086 16.8094 42.3691L17.8066 5.57413L17.3988 5.52651Z",
    fill: "url(#paint4_linear_707_39389)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4316 3.83266C21.4316 3.83266 20.3537 3.74364 19.2785 3.94036C18.5005 4.08293 17.732 4.95887 17.3968 5.52726C17.3968 5.52726 17.425 6.44896 17.3968 6.63914C17.3686 6.82934 13.5681 24.3039 13.8769 31.3879C14.1857 38.472 16.8071 42.3698 16.8071 42.3698L19.2785 42.6718L21.2633 42.8047H21.4316L21.4316 3.83266Z",
    fill: "url(#paint5_linear_707_39389)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9023 42.8609H14.186V43.1034L14.9023 43.1317V42.8609Z",
    fill: "#975225"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4316 43.3122H20.8652C20.8652 43.3122 20.7809 43.2506 20.7717 43.1793C20.7622 43.108 20.7717 42.8039 20.7717 42.8039H21.4316V43.3122Z",
    fill: "#4B68FF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2637 3.84475L21.2637 42.804C21.2637 42.804 19.6721 42.804 19.2789 42.6711L19.2789 3.93969C19.2789 3.93969 20.421 3.78779 21.2637 3.84475Z",
    fill: "#BDEF00"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5176 4.84736C16.5176 4.84736 15.9279 4.39134 15.5065 4.39134C15.0851 4.39134 14.355 4.6195 14.2007 4.84736C14.0462 5.07553 15.942 5.18945 15.942 5.18945L16.5176 4.84736Z",
    fill: "#B57875"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9102 5.26068C16.9102 5.26068 14.9021 5.33196 13.849 5.1894L14.0597 4.7477C14.0597 4.7477 15.0147 4.73338 15.4498 4.7477C15.885 4.76202 16.6575 4.74147 16.6575 4.74147C16.6575 4.74147 16.8117 4.87563 16.9102 5.26068Z",
    fill: "#4B68FF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5137 32.8988H15.8689C15.8689 32.8988 14.0295 32.9558 13.9592 31.3879C13.889 29.82 14.0577 25.125 14.1417 24.8996C14.226 24.6746 14.8437 23.7669 19.9972 24.0284H21.5137V32.8988Z",
    fill: "#23213F"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4316 32.2624C21.4316 32.2624 20.2942 32.2384 20.2639 32.0672C20.2335 31.896 20.6828 26.2139 19.9152 24.0281H21.4316V32.2624Z",
    fill: "#232454"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M17.479 24.9303C17.479 24.9303 19.215 24.7594 19.6922 25.2154C20.1697 25.6714 20.3101 28.0947 20.254 28.7217C20.1979 29.3489 20.0856 31.8674 19.0745 32.2615C18.0635 32.6556 16.6875 32.7695 15.873 32.5986C15.0584 32.4277 14.216 31.544 14.216 30.5461C14.216 29.5481 14.3767 25.9849 14.535 25.415C14.6932 24.8447 16.6976 24.9611 17.479 24.9303Z",
    fill: "#1F2049"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M19.916 26.7546C19.916 26.7546 19.916 29.8617 19.242 31.0876C18.8056 31.8813 18.1833 32.3134 16.9573 32.2564C15.7312 32.1994 15.0872 31.8857 14.8477 30.9736C14.6082 30.0616 14.8477 25.9278 14.8477 25.9278C14.8477 25.9278 15.3663 28.8355 15.9278 29.3771C16.4896 29.9187 17.9932 29.8141 18.3149 29.6053C19.1015 29.0941 19.8878 27.4671 19.916 26.7546Z",
    fill: "#1F1D42"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.83,
    d: "M21.4316 20.9677V21.6519C21.4316 21.6519 16.6292 21.6519 14.551 22.7351C14.551 22.7351 14.4666 22.2221 14.6632 21.994C14.6632 21.994 18.3144 20.6825 21.4316 20.9677Z",
    fill: "#1E1F20"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2889 20.5544L12.7271 20.7826C12.7271 20.7826 12.5446 20.3692 12.292 20.5544C12.0393 20.7396 11.5759 21.7945 11.6461 22.607C11.6461 22.607 12.8538 22.7352 13.0786 22.4644C13.3033 22.1936 12.9942 21.572 12.9942 21.572L13.5839 21.3385C13.5836 21.3385 13.7103 20.6827 13.2889 20.5544Z",
    fill: "#5C91B9"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.51,
    d: "M14.551 22.7349C14.551 22.7349 15.9552 21.6517 21.4316 21.6517V25.044C21.4316 25.044 16.8071 25.0154 14.505 26.4124C14.505 26.4124 13.3715 27.3244 14.551 22.7349Z",
    fill: "#D9908C"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4333 25.0264L21.4336 25.0631C21.3894 25.0634 17.001 25.1001 14.8409 26.2488L14.4447 26.4719C14.4425 26.4732 14.2318 26.5909 14.1208 26.3976L14.1521 26.3789C14.2453 26.541 14.4195 26.4436 14.4269 26.4396L14.8234 26.2161C16.9918 25.0634 21.3891 25.0267 21.4333 25.0264Z",
    fill: "#D9908C"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6389 22.4595C11.6389 22.4595 12.6521 22.5641 12.7834 22.2979C12.9143 22.0318 12.6202 20.8536 12.6202 20.8536L12.9238 21.4808L13.6016 21.1241L13.5838 21.3383L12.9941 21.5717C12.9941 21.5717 13.2234 22.1933 13.0548 22.3452C12.8864 22.4972 12.6242 22.6587 11.6459 22.6064L11.6389 22.4595Z",
    fill: "#76B6DF"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M16.8066 42.3699C16.8066 42.3699 14.5398 37.0268 14.3346 32.4187C14.3346 32.4187 13.8433 32.1006 13.8599 31.7445C13.8599 31.7441 14.2604 38.8562 16.8066 42.3699Z",
    fill: "url(#paint6_linear_707_39389)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M12.0158 30.8284C12.0158 30.8284 12.67 31.1736 12.923 31.9717C13.0539 32.3854 13.4667 34.5301 13.8611 35.9247C14.2275 37.2211 14.582 37.788 14.582 37.788C14.582 37.788 12.9748 31.6882 12.9509 30.3182C12.9509 30.3182 12.3857 30.4658 12.0158 30.8284Z",
    fill: "url(#paint7_linear_707_39389)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M14.6647 21.9951C14.6647 21.9951 16.9981 6.20579 16.9957 5.91723C16.9908 5.37498 16.8917 5.19039 16.8917 5.19039L17.398 5.52782C17.398 5.52782 17.9102 4.8097 18.1328 4.61266C18.1328 4.61266 15.3096 19.3728 15.2118 20.0854C15.1143 20.7979 14.6647 21.9951 14.6647 21.9951Z",
    fill: "url(#paint8_linear_707_39389)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M11.9079 8.316C11.9079 8.316 12.1318 7.52566 12.4722 7.7392C12.8126 7.95273 12.2195 10.1784 12.3599 11.4543C12.5004 12.7302 12.6718 13.9567 12.6718 13.9567C12.6718 13.9567 12.3783 8.39257 13.084 6.83183C13.084 6.83151 11.9972 7.46341 11.9079 8.316Z",
    fill: "url(#paint9_linear_707_39389)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9141 30.3183C29.9141 30.3183 31.3898 30.7678 31.6272 32.0571C33.3123 41.2078 28.6782 42.8613 28.6782 42.8613H27.9622C27.9622 42.8613 27.0495 42.362 26.6282 42.3694C26.2068 42.3769 26.0572 42.3694 26.0572 42.3694",
    fill: "url(#paint10_linear_707_39389)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7783 6.83072C29.7783 6.83072 30.6802 7.37981 30.905 8.08299C31.1298 8.78616 31.2795 14.0125 31.0173 14.6394C30.7551 15.2664 30.1546 16.1414 30.1546 16.1414L29.2631 14.7534L29.7783 6.83072Z",
    fill: "url(#paint11_linear_707_39389)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4664 5.52755L25.9531 5.2614L29.0143 5.19012C29.0143 5.19012 30.2955 6.77234 30.2446 10.4781C30.1937 14.1839 29.9128 30.319 29.9128 30.319C29.9128 30.319 28.3776 40.5096 26.0559 42.3701L25.0586 5.57517L25.4664 5.52755Z",
    fill: "url(#paint12_linear_707_39389)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4333 3.83267C21.4333 3.83267 22.5112 3.74364 23.5864 3.94037C24.3644 4.08294 25.1329 4.95887 25.4681 5.52727C25.4681 5.52727 25.4399 6.44896 25.4681 6.63915C25.4963 6.82934 29.2968 24.3039 28.988 31.3879C28.6792 38.472 26.0578 42.3698 26.0578 42.3698L23.5864 42.6718L21.6016 42.8047H21.4333L21.4333 3.83267Z",
    fill: "url(#paint13_linear_707_39389)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9614 42.8607H28.6777V43.1032L27.9614 43.1315V42.8607Z",
    fill: "#975225"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4335 43.3132H21.9999C21.9999 43.3132 22.0842 43.2515 22.0934 43.1803C22.1029 43.109 22.0934 42.8049 22.0934 42.8049H21.4335V43.3132Z",
    fill: "#4B68FF"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6012 3.84433L21.6012 42.8036C21.6012 42.8036 23.1928 42.8036 23.5859 42.6707L23.5859 3.93927C23.5859 3.93927 22.4439 3.78736 21.6012 3.84433Z",
    fill: "#BDEF00"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M26.348 4.84687C26.348 4.84687 26.9377 4.39085 27.3591 4.39085C27.7804 4.39085 28.5106 4.61901 28.6649 4.84687C28.8194 5.07504 26.9236 5.18896 26.9236 5.18896L26.348 4.84687Z",
    fill: "#B57875"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9545 5.26044C25.9545 5.26044 27.9625 5.33172 29.0156 5.18916L28.8049 4.74745C28.8049 4.74745 27.85 4.73313 27.4148 4.74745C26.9797 4.76177 26.2072 4.74123 26.2072 4.74123C26.2072 4.74123 26.0529 4.87539 25.9545 5.26044Z",
    fill: "#4B68FF"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4325 32.8977H27.0776C27.0776 32.8977 28.917 32.9547 28.9872 31.3867C29.0574 29.8188 28.8888 25.1238 28.8047 24.8985C28.7204 24.6734 28.1028 23.7657 22.9492 24.0272H21.4328V32.8977H21.4325Z",
    fill: "#23213F"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4328 32.2617C21.4328 32.2617 22.5702 32.2378 22.6005 32.0665C22.6309 31.8953 22.1816 26.2133 22.9492 24.0275H21.4328V32.2617Z",
    fill: "#232454"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3875 24.9305C25.3875 24.9305 23.6514 24.7596 23.1742 25.2156C22.6968 25.6716 22.5563 28.0949 22.6124 28.7218C22.6686 29.3491 22.7808 31.8676 23.7919 32.2617C24.803 32.6558 26.179 32.7697 26.9935 32.5988C27.808 32.4279 28.6504 31.5442 28.6504 30.5462C28.6504 29.5483 28.4897 25.9851 28.3315 25.4151C28.1732 24.8449 26.1688 24.9613 25.3875 24.9305Z",
    fill: "#1F2049"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9503 26.7558C22.9503 26.7558 22.9503 29.863 23.6243 31.0888C24.0607 31.8825 24.6829 32.3146 25.909 32.2576C27.135 32.2007 27.779 31.8869 28.0186 30.9749C28.2581 30.0628 28.0186 25.929 28.0186 25.929C28.0186 25.929 27.5 28.8367 26.9385 29.3783C26.3767 29.9199 24.8731 29.8153 24.5514 29.6065C23.7648 29.0954 22.9785 27.4683 22.9503 26.7558Z",
    fill: "#1F1D42"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.83,
    d: "M21.4334 20.9683V21.6525C21.4334 21.6525 26.2358 21.6525 28.314 22.7358C28.314 22.7358 28.3984 22.2228 28.2018 21.9946C28.2018 21.9946 24.5506 20.6832 21.4334 20.9683Z",
    fill: "#1E1F20"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5766 20.5547L30.1384 20.7828C30.1384 20.7828 30.3209 20.3694 30.5736 20.5547C30.8263 20.7399 31.2896 21.7948 31.2194 22.6072C31.2194 22.6072 30.0117 22.7355 29.787 22.4647C29.5622 22.1939 29.8713 21.5722 29.8713 21.5722L29.2816 21.3388C29.2819 21.3388 29.1552 20.6829 29.5766 20.5547Z",
    fill: "#5C91B9"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.51,
    d: "M28.3132 22.7358C28.3132 22.7358 26.909 21.6526 21.4325 21.6526V25.0449C21.4325 25.0449 26.0571 25.0163 28.3592 26.4133C28.3592 26.4133 29.4927 27.3253 28.3132 22.7358Z",
    fill: "#D9908C"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4317 25.0258C21.4758 25.0261 25.8731 25.0628 28.0413 26.2158L28.4381 26.4396C28.4454 26.4439 28.6202 26.5407 28.7129 26.3789L28.7441 26.3976C28.6331 26.5909 28.4221 26.4729 28.4203 26.4716L28.0238 26.2481C25.8636 25.0998 21.4755 25.0628 21.4314 25.0628L21.4317 25.0258Z",
    fill: "#D9908C"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2266 22.4598C31.2266 22.4598 30.2133 22.5644 30.0821 22.2982C29.9511 22.0321 30.2452 20.8539 30.2452 20.8539L29.9416 21.4811L29.2639 21.1244L29.2817 21.3386L29.8714 21.572C29.8714 21.572 29.642 22.1936 29.8107 22.3456C29.979 22.4975 30.2412 22.659 31.2195 22.6067L31.2266 22.4598Z",
    fill: "#76B6DF"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M26.0567 42.3693C26.0567 42.3693 28.3236 37.0262 28.5288 32.418C28.5288 32.418 29.0201 32.0999 29.0035 31.7438C29.0035 31.7435 28.603 38.8556 26.0567 42.3693Z",
    fill: "url(#paint14_linear_707_39389)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M30.8496 30.8284C30.8496 30.8284 30.1955 31.1736 29.9425 31.9717C29.8115 32.3854 29.3988 34.5301 29.0044 35.9247C28.6379 37.2211 28.2834 37.788 28.2834 37.788C28.2834 37.788 29.8907 31.6882 29.9146 30.3182C29.9146 30.3182 30.4798 30.4658 30.8496 30.8284Z",
    fill: "url(#paint15_linear_707_39389)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M28.2012 21.9952C28.2012 21.9952 25.8677 6.20597 25.8702 5.91741C25.8751 5.37516 25.9742 5.19057 25.9742 5.19057L25.4679 5.528C25.4679 5.528 24.9557 4.80988 24.7331 4.61284C24.7331 4.61284 27.5563 19.373 27.6541 20.0855C27.7516 20.7981 28.2012 21.9952 28.2012 21.9952Z",
    fill: "url(#paint16_linear_707_39389)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M30.9551 8.31489C30.9551 8.31489 30.7312 7.52456 30.3908 7.73809C30.0504 7.95163 30.6435 10.1773 30.5031 11.4532C30.3626 12.7291 30.1912 13.9556 30.1912 13.9556C30.1912 13.9556 30.4847 8.39147 29.779 6.83072C29.779 6.83041 30.8658 7.4623 30.9551 8.31489Z",
    fill: "url(#paint17_linear_707_39389)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M12.3302 14.4263C12.3186 14.3566 12.3078 14.2869 12.2986 14.2169C12.302 14.2414 12.3051 14.2657 12.3084 14.2903C12.2419 13.782 12.2422 13.2665 12.309 12.7582C12.3057 12.7828 12.3026 12.8071 12.2992 12.8317C12.3133 12.7268 12.3302 12.6222 12.3498 12.5179C12.3636 12.4438 12.3609 12.3719 12.3225 12.305C12.2894 12.2477 12.2247 12.1929 12.16 12.178C12.0257 12.1469 11.854 12.2191 11.8254 12.371C11.688 13.1006 11.6825 13.8408 11.8058 14.573C11.8165 14.6374 11.8776 14.7062 11.9309 14.7379C11.9892 14.7725 12.0751 14.7871 12.1407 14.7656C12.2066 14.7442 12.2701 14.7025 12.3032 14.6386C12.3388 14.5698 12.3431 14.5035 12.3302 14.4263Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_707_39389",
    x1: 21.354,
    y1: 38.5543,
    x2: 21.354,
    y2: 31.9977,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.243,
    stopColor: "#60633F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4385
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7458,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_707_39389",
    x1: 21.354,
    y1: 13.8372,
    x2: 21.354,
    y2: 7.28062,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.243,
    stopColor: "#60633F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4385
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7458,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_707_39389",
    x1: 10.4224,
    y1: 36.5996,
    x2: 16.9511,
    y2: 36.0733,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4637,
    stopColor: "#506CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B68FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_707_39389",
    x1: 11.5665,
    y1: 11.494,
    x2: 13.6586,
    y2: 11.4216,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4637,
    stopColor: "#506CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B68FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_707_39389",
    x1: 12.2302,
    y1: 23.8075,
    x2: 17.9666,
    y2: 23.6712,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4637,
    stopColor: "#506CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B68FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_707_39389",
    x1: 13.2913,
    y1: 23.3384,
    x2: 21.6607,
    y2: 23.0617,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4637,
    stopColor: "#506CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B68FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_707_39389",
    x1: 16.8066,
    y1: 37.0571,
    x2: 13.8593,
    y2: 37.0571,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#020202"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_707_39389",
    x1: 14.5819,
    y1: 34.0532,
    x2: 12.0157,
    y2: 34.0532,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#020202"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_707_39389",
    x1: 18.1332,
    y1: 13.3037,
    x2: 14.6648,
    y2: 13.3037,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#020202"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_707_39389",
    x1: 13.084,
    y1: 10.3941,
    x2: 11.908,
    y2: 10.3941,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#020202"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_707_39389",
    x1: 25.6119,
    y1: 36.5994,
    x2: 32.1405,
    y2: 36.0732,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4637,
    stopColor: "#506CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B68FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_707_39389",
    x1: 29.1212,
    y1: 11.4931,
    x2: 31.2133,
    y2: 11.4207,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4637,
    stopColor: "#506CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B68FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_707_39389",
    x1: 24.6696,
    y1: 23.8085,
    x2: 30.4061,
    y2: 23.6723,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4637,
    stopColor: "#506CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B68FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_707_39389",
    x1: 20.8655,
    y1: 23.3384,
    x2: 29.235,
    y2: 23.0617,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4637,
    stopColor: "#506CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B68FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_707_39389",
    x1: 26.0568,
    y1: 37.0564,
    x2: 29.0041,
    y2: 37.0564,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#020202"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_707_39389",
    x1: 28.2836,
    y1: 34.0532,
    x2: 30.8497,
    y2: 34.0532,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#020202"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_707_39389",
    x1: 24.7327,
    y1: 13.3039,
    x2: 28.2011,
    y2: 13.3039,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#020202"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_707_39389",
    x1: 29.7791,
    y1: 10.393,
    x2: 30.9551,
    y2: 10.393,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#020202"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCar1);
export default __webpack_public_path__ + "static/media/car1.0b41befe.svg";
export { ForwardRef as ReactComponent };